import CompanySelect from "../../Company/CompanySelect";
import {Button, FormGroup} from "reactstrap";
import {I18n} from "../../../I18n/components/statistics";
import React from "react";
import Datetime from "react-datetime";
import moment from "moment";
import SingleSelect from "../../Common/SingleSelect";
import "./geo-activity.css"
import CsvFileInput from "../../Common/CsvFileInput";

const GeoActivityControls = props => {

    const filterByCompanies = props.company.types.includes('OPERATOR') ? (
        <CompanySelect
            className="search-filter"
            lang={props.lang}
            companyId={props.companyIdFilter}
            companies={props.companies}
            onCompanyChange={props.onFilterClick('companyIdFilter')}
        />) : null;

    return (
        <FormGroup className="d-flex flex-wrap align-items-start">
            {filterByCompanies}
            <SingleSelect
                className="search-filter"
                lang={props.lang}
                id={props.salesPointIdFilter}
                valueList={props.stores}
                onChange={props.onFilterClick('salesPointIdFilter')}
                defaultOptionText={I18n[props.lang].geoActivity.salesPoint}
            />
            <Datetime
                className="data-filter"
                locale="en-gb"
                timeFormat={false}
                closeOnSelect={true}
                inputProps={{placeholder: `${I18n[props.lang].geoActivity.dateFrom}`}}
                onChange={props.dateFromTimeChange}
                value={props.dateFrom ? moment(props.dateFrom).format('DD.MM.YYYY') : ''}
            />
            <Datetime
                className="data-filter date-to"
                locale="en-gb"
                timeFormat={false}
                closeOnSelect={true}
                inputProps={{placeholder: `${I18n[props.lang].geoActivity.dateTo}`}}
                onChange={props.dateToTimeChange}
                value={props.dateTo ? moment(props.dateTo).format('DD.MM.YYYY') : ''}
            />
            <Button
                className="mr-2"
                color="primary"
                type="button"
                onClick={props.getFiltered}
            >
                {I18n[props.lang].geoActivity.filter}
            </Button>
            <Button
                className="mr-2"
                color="primary"
                type="button"
                onClick={props.clearFilters}
            >
                {I18n[props.lang].geoActivity.resetFilters}
            </Button>
            <Button
                className="mr-2"
                color={props.isCsvLoading ? "secondary" : "primary"}
                type="button"
                disabled={props.isCsvLoading}
                onClick={props.downloadCsv}
            >
                {props.isCsvLoading ?
                    <i className="fa fa-spinner fa-spin mr-2"/> : null} {I18n[props.lang].geoActivity.downloadCsv}
            </Button>
            <CsvFileInput
                label={I18n[props.lang].geoActivity.updateLocation}
                onFileLoad={props.onUpdateLocationFileInput}
                isLoading={props.isUpdateLocationLoading}
            />
        </FormGroup>
    )
}

export default GeoActivityControls;


// WEBPACK FOOTER //
// ./src/components/Statistics/GeoActivity/GeoActivityControls.js